<template>
  <div class="app_container" :class="{ 'list-drag': dragaable }">
    <div class="header">
      <span>
        <butn class="btn-wrapper m-r-16" btntype="primary" title="新增" v-permission="'clientIndexConfig:save'"
          @click="openAppletSpecial">
        </butn>
        <el-checkbox :disabled="dragDisabled" v-model="dragaable" v-permission="'clientIndexConfig:updateOrderByDrag'"
          class="drag-box">拖拽排序</el-checkbox>
      </span>
      <span>
        <el-select class="m-r-16" v-if="isTopLevel" v-model="deptId" placeholder="请选择学院" @change="deptChange">
          <el-option v-for="item in collegeList" :key="item.uuid" :label="item.deptName" :value="item.uuid"></el-option>
        </el-select>
        <!-- <butn class="btn-wrapper" btntype="primary" title="刷新" @click="searchHandle"></butn> -->
      </span>
      
    </div>
    <div>
      <Table @selection-change="selectionChange" row-key="uuid" :data="featureList" :deptLevelCode="deptLevelCode"
        @handleEdit="openAppletSpecial" @dealDelete="delHandle" @setDown="setDownHandle"
        @handleShare="openAppletShare" @handleInfo="handleInfo"/>
    </div>

    <AppletSpecialAdd :showAppletSpecial="showAppletSpecial" :clientType="actionType" v-if="showAppletSpecial.flag"
      @closeDialog="closeAppletSpecial" />
    <AppletShareModal :showModal="showAppletShare" v-if="showAppletShare.flag" @reloadTable="reloadTable"
      @closeDialog="closeAppletShare" />

  </div>

</template>

<script>

import {
  getClientIndexConfigList,
  deleteClientIndexConfig,
  updateOnlineStatus,
  orderByDrag,
} from "@/api/resourceService";
import { statisticDeptList } from "@/api/dept";
import Table from "./table.js";
import butn from "@/components/button/index";
import { getItem } from "@/utils/storage";
import AppletSpecialAdd from "../appletSpecial/add.vue";
import AppletShareModal from "../appletSpecial/share/index.vue";
import Sortable from "sortablejs";
export default {
  name: "featureContent",
  components: {
    AppletSpecialAdd,
    AppletShareModal,
    butn,
    Table
  },
  props: {
    actionType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dragaable: false,
      userType: 0,
      deptId: null,
      deptLevelCode: "",
      isTopLevel: false, 

      featureList: [],
      checkArray: [],
      collegeList: [],

      showAppletSpecial: {
        flag: false,
      },
      showAppletShare: {
        flag: false
      }
    };
  },
  created() {
    this.deptLevelCode = getItem("deptLevelCode");
    this.isTopLevel = this.deptLevelCode == "001";
    if (this.isTopLevel) {
      statisticDeptList()
        .then(({ code, data }) => {
          if (code === 0) {
            this.collegeList = data;
            this.deptId = data[0].uuid || null;
            this.deptLevelCode = data[0].deptLevelCode;
            this.searchHandle({});
          }
        })
        .catch(() => { });
    } else {
      this.$nextTick(() => {
        this.searchHandle({});
      });
    }

  },
  mounted() { },
  methods: {

    searchHandle() {
      let params = {
        clientType: this.actionType,
        moduleType: 1,
      }
      if (this.isTopLevel) {
        params.queryDeptLevelCode = this.deptLevelCode;
      }
      getClientIndexConfigList(params).then((res) => {
        if (!res || res.code != 0) return;
        this.featureList = res.data;
      });
    },

    deptChange(val) {
      this.deptId = val;
      let item = this.collegeList.filter((item) => item.uuid == val);
      this.deptLevelCode = item[0].deptLevelCode;
      this.searchHandle()
    },

    // 编辑-小程序特色内容
    openAppletSpecial(item = {}) {
      this.showAppletSpecial.flag = true;
      this.showAppletSpecial.id = "";
      if (item.uuid) {
        this.showAppletSpecial.id = item.uuid;
      }
    },
    // 关闭编辑-小程序特色内容
    closeAppletSpecial(flag) {
      this.showAppletSpecial.flag = false;
      this.showAppletSpecial.id = "";
      if (flag) {
        this.searchHandle();
      }
    },

    handleInfo(item = {}) {
      this.showAppletSpecial = {
        flag: true,
        id: item.uuid,
        isDetail: true,
      }
    },

    // 删除-小程序特色内容配置
    delHandle(data) {
      this.$confirm(`确认删除该配置吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteClientIndexConfig({ uuids: [data.uuid] }).then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新列表
              this.searchHandle(this.dataname);
            }
          });
        })
        .catch(() => { });
    },
    // 上下线-小程序特色内容
    setDownHandle(id, status) {
      let text = "";
      if (status == 1) {
        text = "确认上线该配置吗？";
      } else {
        text = "确认下线该配置吗？";
      }
      this.$confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateOnlineStatus({
            uuid: id,
            onlineStatus: status,
          }).then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新列表
              this.searchHandle(this.dataname);
            }
          });
        })
        .catch(() => { });
    },

    // 共享-小程序特色内容
    openAppletShare(item = {}) {
      if (item.uuid) {
        this.showAppletShare.id = item.uuid;
      }
      this.showAppletShare.flag = true;
    },
    // 小程序特色内容-关闭共享
    closeAppletShare() {
      this.showAppletShare.flag = false;
      this.showAppletShare.id = "";
    },

    // 共享操作后-刷新
    reloadTable() {
      this.searchHandle(this.dataname);
    },


    selectionChange() {
      this.checkArray = selections;
    },

    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            const oldRow = _this.featureList[oldIndex];
            const newRow = _this.featureList[newIndex];
            let flagDept = true
            console.log('----1111-----', oldRow.deptId, newRow.deptId);
            
            if (oldRow.deptId !== newRow.deptId) {
              _this.$message({
                message: "不同所属学院下不能排序",
                type: "error",
              });
              flagDept = false;
              // // 列表刷新
              _this.$nextTick(() => {
                _this.reloadTable();
              });
            }
            if (flagDept) { 
              let offset;
              let params = {};
              offset = newIndex - oldIndex;
              params = {
                upOrDown: Number(offset) > 0 ? 1 : -1,
                dragUuid: oldRow.uuid,
                otherUuid: newRow.uuid,
              };
              orderByDrag(params).then((res) => {
                if (!res || res.code != 0) return;
                _this.$message({
                  message: "排序成功",
                  type: "success",
                });
                _this.reloadTable()
              });
            }
            
          },
        });
      }
    },
  },
  computed: {
    itemIds() {
      return this.checkArray.map((item) => item.uuid);
    },
    dragDisabled() {
      if (this.featureList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.m-r-16 {
  margin-right: 16px;
}
</style>
